/**
 * Find the store id value within a given lookup string
 * @param lookup the lookup string
 * @return storeId string or undefined
 */
export const getQueryStoreId = (lookup = '') =>
    (lookup.match(/(?:\?|&)store=([0-9]{6})/) || [])[1];

/**
 * Verifies if a store id is a valid one
 * @param storeId store id string to test
 * @return boolean
 */
export const isValidStoreId = (storeId: string) => /[0-9]{6}/.test(storeId);
